export default "__VITE_ASSET__Pj24Hkih__"